var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card } from '@philips-internal/oswald-ui-components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import NonLabExamCardAPI from './non-lab-exam-card-api';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import moment from 'moment';
import './non-lab-exam-card.css';
import { ReactComponent as ReportCheck } from '../../assets/images/global/report-check.svg';
import { ReactComponent as Time } from '../../assets/images/global/reportPendingRelease.svg';
let NonLabExamCard = class NonLabExamCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { dsTituloLaudo, dtExame, onClick, } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        dsTituloLaudo,
                        dtExame,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener,
    }; }
    renderContent() {
        const { dsTituloLaudo, dtExame } = this.props;
        const formattedDtExame = moment(String(dtExame)).format('L LT');
        return (React.createElement("div", { className: "c-non-lab-exam-card-content-item" },
            React.createElement("div", { className: "c-non-lab-exam-card-data" },
                React.createElement("p", { className: "c-non-lab-exam-card__description" }, dsTituloLaudo),
                React.createElement("p", { className: "c-non-lab-exam-card__date" }, formattedDtExame)),
            React.createElement("div", { className: 'non-lab-icon' }, this.renderIcon())));
    }
    render() {
        const { dsTituloLaudo, dtExame } = this.props;
        return (React.createElement(Card, { className: 'c-non-lab-exam-card', selectionType: SelectionType.SINGLE, width: 12, key: `${dsTituloLaudo} + ${dtExame}`, onClick: this.handleClick, uuid: generateUUID() },
            React.createElement("div", { className: "c-non-lab-exam-card__wrapper" }, this.renderContent())));
    }
    renderIcon() {
        if (this.props.dtLiberacao) {
            return React.createElement(ReportCheck, null);
        }
        return React.createElement(Time, null);
    }
};
NonLabExamCard = __decorate([
    AwesomeComponent({ api: NonLabExamCardAPI, type: ComponentType.DATA_DISPLAY })
], NonLabExamCard);
export default NonLabExamCard;
//# sourceMappingURL=non-lab-exam-card.js.map